import { render, staticRenderFns } from "./christmaswineinvestment.vue?vue&type=template&id=b3830a9e&scoped=true"
import script from "./christmaswineinvestment.vue?vue&type=script&lang=js"
export * from "./christmaswineinvestment.vue?vue&type=script&lang=js"
import style0 from "./christmaswineinvestment.vue?vue&type=style&index=0&id=b3830a9e&prod&scoped=true&lang=css"
import style1 from "./christmaswineinvestment.vue?vue&type=style&index=1&id=b3830a9e&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3830a9e",
  null
  
)

export default component.exports